<template>
  <modal
    class="alertModal"
    :show="isAlertOpen"
    :closeModal="closeModal"
    :noFooter="noFooter"
  >
    <h1 slot="header" v-if="header" v-html="header"></h1>
    <div slot="body" v-html="message"></div>
    <div
      v-if="confirmText"
      slot="footer"
      :class="{ button_wrapper: canCancel }"
    >
      <button
        :class="{ button12: true, can_cancel: canCancel }"
        @click="handleClick(true, 'confirm')"
        ref="btn"
      >
        {{ confirmText }}
      </button>
      <button
        v-if="canCancel"
        :class="{ button12: true, can_cancel: true, cancel_button: true }"
        @click="handleClick(true, 'cancel')"
        ref="btn"
      >
        취소
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/views/base/Modal'
import { mapState, mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  props: {},
  watch: {
    isAlertOpen: function(val) {
      if (val) {
        this.buttonFocus()

        if (val && this.showFooterInSecond > -1) {
          setTimeout(() => {
            this.setNoFooter(false)
          }, this.showFooterInSecond * 1000)
        }
      }
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      needFooter: false
    }
  },
  computed: {
    ...mapGetters('modal', [
      'isAlertOpen',
      'header',
      'message',
      'confirmText',
      'callback',
      'cancelCallback',
      'canCancel',
      'noFooter',
      'showFooterInSecond'
    ])
  },
  methods: {
    ...mapActions('modal', ['closeModal', 'setNoFooter']),
    handleClick(callCallback, type) {
      this.setNoFooter(false)
      if (type === 'confirm') {
        if (callCallback && typeof this.callback === 'function') {
          this.callback()
        }
      } else if (type === 'cancel') {
        if (callCallback && typeof this.cancelCallback === 'function') {
          this.cancelCallback()
        }
      }

      this.closeModal()
    }
  },
  mounted() {
    this.buttonFocus()
  }
}
</script>
<style lang="scss" scoped>
.can_cancel {
  width: 49%;
}
.cancel_button {
  background-color: white;
  border: 1px solid #d8d8d8;
  color: black;
}
.button_wrapper {
  display: flex;
  justify-content: space-between;
}
</style>
